export class UpdateManager {
  private _queueName: string
  private _currentFunction: () => Promise<void>
  private _nextFunction: () => Promise<void>
  private _paceInSeconds = 5
  private _activated: boolean
  private _interval: NodeJS.Timeout
  // private _perfStart: number

  constructor({
    paceInSeconds = 5,
    queueName,
  }: {
    queueName: string
    paceInSeconds?: number
  }) {
    this._paceInSeconds = paceInSeconds
    this._queueName = queueName
  }

  private async activate() {
    // this.doWork()
    if (this._activated) {
      return
    }

    await this.doWork()

    this._activated = true
    let idleCounter = 0

    this._interval = setInterval(async () => {
      // console.log('*** interval ***', this._queueName, {
      //   curr: Boolean(this._currentFunction),
      //   next: Boolean(this._nextFunction),
      // })

      const hasWorkToDo = await this.doWork()

      // console.log('hasWorkToDo', hasWorkToDo, this._queueName)

      if (!hasWorkToDo) {
        idleCounter++
        // console.log('idleCounter', idleCounter, this._queueName)
        if (idleCounter > 2) {
          this.clear()
        }
      }
    }, this._paceInSeconds * 1000)
  }

  private async doWork() {
    if (this._currentFunction) {
      return false
    }

    if (!this._nextFunction) {
      return false
    }

    this._currentFunction = this._nextFunction
    this._nextFunction = undefined

    if (this._currentFunction) {
      // const taskStartedTime = performance.now()
      // console.log('*** starting current update task ***', this._queueName)
      // console.log(
      //   'time since last run',
      //   this._queueName,
      //   (performance.now() - this._perfStart) / 1000
      // )
      await this._currentFunction()
      this._currentFunction = undefined
      // this._perfStart = performance.now()
      // console.log(
      //   '*** ends current update task *** ',
      //   this._queueName,
      //   (performance.now() - taskStartedTime) / 1000
      // )
    }

    return true
  }

  // eslint-disable-next-line
  public addTask(task: () => Promise<any>) {
    this._nextFunction = task
    this.activate()
  }

  public get isWorking() {
    return this._currentFunction !== undefined
  }

  public clear() {
    this._currentFunction = undefined
    this._nextFunction = undefined
    this._activated = false
    clearInterval(this._interval)
  }
}
